window.jQuery &&
    document.querySelector(".reviews-js") &&
    $(document).ready(function () {
        $(".reviews-js").slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            arrows: !0,
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 2, arrows: !1, centerMode: true, centerPadding: '40px' } },
                { breakpoint: 640, settings: { slidesToShow: 1, slidesToScroll: 1, arrows: !1, centerMode: true, centerPadding: '30px' } },
            ],
        });
    });
window.jQuery &&
    document.querySelector(".video-js") &&
    $(document).ready(function () {
        $(".video-js").slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            arrows: !0,
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1, arrows: !1, centerMode: true, centerPadding: '40px' } },
                { breakpoint: 640, settings: { slidesToShow: 2, slidesToScroll: 1, arrows: !1, centerMode: true, centerPadding: '30px' } },
                { breakpoint: 420, settings: { slidesToShow: 1, slidesToScroll: 1, arrows: !1, centerMode: true, centerPadding: '20px' } },
            ],
        });
    });
window.jQuery &&
    document.querySelector(".logos-js") &&
    $(document).ready(function () {
        $(".logos-js").slick({
            slidesToShow: 4,
            arrows: !0,
            autoplay: !0,
            slidesToScroll: 2,
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 3 } },
                { breakpoint: 640, settings: { slidesToShow: 2 } },
            ],
        });
    });
window.jQuery &&
    document.querySelector(".cards-js") &&
    $(document).ready(function () {
        $(".cards-js").slick({
            slidesToShow: 4,
            arrows: !0,
            autoplay: !0,
            slidesToScroll: 2,
            centerMode: !0,
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 2 } },
                { breakpoint: 640, settings: { slidesToShow: 1 } },
            ],
        }),
            $(window).on("resize orientationchange", function () {
                $(".cards-js").slick("resize");
            });
    });
const s = () => {
    const e = document.querySelector(".product-sticky-add-to-cart");
    e &&
        document.addEventListener("scroll", () => {
            window.scrollY >= 1045 ? e.classList.add("product-sticky-add-to-cart--active") : e.classList.remove("product-sticky-add-to-cart--active");
        });
};
document.addEventListener("DOMContentLoaded", () => {
    s();
});
